import {useEffect} from 'react';
import {createRoot} from 'react-dom/client';
import {GlobalNav} from '~/common/components/MegaNav/MegaNavVariant/components/GlobalNav/GlobalNav';
import {LocalNav} from '~/common/components/MegaNav/MegaNavVariant/components/LocalNav/LocalNav';
import {globalNavId, localNavId} from '~/common/components/MegaNav/MegaNavVariant/constants';
import {TrackingProvider} from '~library/context/tracking/tracking-context';
import './MegaNavVariant.scss';

export const MegaNavVariant = () => {
  useEffect(() => {
    const globalNavContainer = document.getElementById(globalNavId);
    const localNavContainer = document.getElementById(localNavId);

    let globalNavRoot: ReturnType<typeof createRoot> | null = null;
    let localNavRoot: ReturnType<typeof createRoot> | null = null;

    if (globalNavContainer) {
      // Create new root and render localNav
      globalNavRoot = createRoot(globalNavContainer);
      globalNavRoot.render(
        <TrackingProvider>
          <GlobalNav />
        </TrackingProvider>
      );
    }

    if (localNavContainer) {
      // Create new root and render globalNav
      localNavRoot = createRoot(localNavContainer);
      localNavRoot.render(
        <TrackingProvider>
          <LocalNav />
        </TrackingProvider>
      );
    }

    evite.resolve('nav');

    return () => {
      // Cleanup roots on unmount
      if (globalNavRoot) {
        globalNavRoot.unmount();
      }
      if (localNavRoot) {
        localNavRoot.unmount();
      }
    };
  }, []);

  return null;
};
